import {useQuery} from "@tanstack/react-query";
import {createIncomingCode} from "../../../../../api/inventory/IncomingApi";

export const useCreateIncomingCode = () => {
    const {data} = useQuery({
        queryKey: ["createIncomingCode"],
        queryFn: async () => await createIncomingCode(),
        select: (res) => res?.data.result?.incomingCode ?? "",
    });

    return {data};
};
